import React, { useState } from 'react';
import { getLoggedInUser } from "../../../../helpers/authUtils";
import moment from 'moment';
import IconLink from '../../../../assets/svg/ic-actions-new-window.svg';
import IconImpressora from '../../../../assets/svg/print.svg';
import { openSolicExame } from '../../../../Libs/Docs.js';
import ModalEnvio from '../../../../gb-components/ModalEnvio';
import ReactHtmlParser from "react-html-parser";

const CardExames = ({ interacao, paciente, Hora, item, DataCriacao, profissional }) => {

    const [profNome, setProfNome] = useState('');
    const [isVisibleSend, setIsVisibleSend] = useState(false);
    const sending = false;

    const renderBody = () => {
        return (<>
            <div className="row">
                <div className="col-12">
                    <strong>Médico:  </strong>{profissional}
                </div>
            </div>
            <div className="row">
                <div className="col-12 mb-2">
                    <strong>Data:  </strong>{moment(item.DataCriacao, 'DD-MM-YYYY').format("DD/MM/YYYY")}
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <p style={{ fontSize: 17 }}>
                        <strong>Exames Solicitados</strong>
                    </p>
                </div>
                <div className="col-12" >
                    <table className="table table-striped" style={{ fontSize: 14 }}>
                        <thead>
                            <tr>
                                <th>Código</th>
                                <th>Exame</th>
                            </tr>
                        </thead>
                        <tbody>
                            {item.Exames.map((ex, idx) => {
                                return (
                                    <tr key={idx}>
                                        <td>{ex.codigo}</td>
                                        <td>{ex.exame}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
                <div className="col-12" style={{ marginTop: 0 }}>
                    {item.obs ? (
                        <div style={{ fontSize: 12 }}>
                            <strong>Observações: </strong>{ReactHtmlParser(item.obs)}
                        </div>) : null}
                </div>
            </div>
        </>
        )
    }


    return (
        <>
            <div className={"gb-card mb-3"}>
                <div className={getLoggedInUser().username === profissional ? "gb-card-header profissional" : "gb-card-header"}>
                    <p>{profissional ? profissional : profNome}</p>
                    <div style={{ textAlign: getLoggedInUser().username === profissional ? 'right' : null, }}>
                        {DataCriacao ? (
                            <span className="gb-card-header-hora">
                                {DataCriacao.replace("-", "/").replace("-", "/")}{" "}{Hora ? Hora : ""}
                            </span>
                        ) : null}

                        <div style={{ textAlign: getLoggedInUser().username === profissional ? 'left' : 'right' }}>

                            <a href="#" onClick={() => {
                                openSolicExame(paciente.id, item.id);
                            }}>
                                <img src={IconImpressora} style={{ marginLeft: 15 }} />
                            </a>

                            <a href="#" onClick={() => setIsVisibleSend(true)}>
                                <img src={IconLink} style={{ marginLeft: 15 }} />
                            </a>

                        </div>
                    </div>


                </div>

                <div className="gb-card-body">
                    {renderBody()}
                </div>

            </div>

            {(item) ? <ModalEnvio visible={isVisibleSend}
                close={() => setIsVisibleSend(false)}
                pacienteId={paciente.id}
                card={'solicitacao_exame'}
                docId={item.id}
                email={paciente.paciente.email}
                telefone={paciente.paciente.whatsapp ? paciente.paciente.whatsapp : paciente.paciente.telefones} /> : null}
        </>
    )
}

export default CardExames;